
































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Button from '@/components/Button.vue';
import { Getter, namespace } from 'vuex-class';
import Loader from '@/components/Loader.vue';
import TextField from '@/components/form/TextField.vue';
import { ValidationError, Validator } from 'class-validator';
import i18next from 'i18next';
import { NamedRoutes } from '@/routes/routes';
import AuthRedirect from '@/app/utils/AuthRedirect';

const AuthModule = namespace('auth');

@Component({
  components: {
    NavBar,
    TabBar,
    Button,
    Loader,
    TextField,
  },
})
export default class RegisterConfirmationView extends Vue {
  @Prop(Object)
  private pagedata!: any;

  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @AuthModule.Action('confirmUserRegistration')
  public confirmUserRegistration!: any;

  @Getter
  public loggedInUser!: boolean;

  public errors: ValidationError[] = [];

  public code: string = '';

  public confirmationIsLoading: boolean = false;

  public getFieldError(fieldName: string): ValidationError | null {
    const error = this.errors.find(e => e.property === fieldName);
    return error || null;
  }

  public removeFieldError(fieldName: string): void {
    let index = 0;
    this.errors.forEach((err, i) => {
      if (err.property === fieldName) {
        index = i;
      }
    });
    this.errors.splice(index, 1);
  }

  public async confirm(): Promise<void> {
    this.errors = [];
    const validator = new Validator();

    if (validator.isEmpty(this.code)) {
      this.addError('code', 'isEmpty', i18next.t('registerConfirmation.validation.code.isEmpty'));
    }

    if (!validator.length(this.code, 6, 6)) {
      this.addError('code', 'length', i18next.t('registerConfirmation.validation.code.length'));
    }

    if (this.errors.length > 0) {
      return;
    }

    this.confirmationIsLoading = true;

    try {
      await this.confirmUserRegistration(this.code);
      await this.$store.dispatch('loginUser', true);
      const redirectRoute = AuthRedirect.getRedirect();
      if (redirectRoute.name) {
        await this.$router.push(redirectRoute);
        AuthRedirect.resetRedirectData();
        return;
      }
      await this.$router.push({ name: NamedRoutes.benefitsOverview });
    } catch (e) {
      console.log('Failed to confirm user registration', e);

      if (e && e.response && e.response.status === 422) {
        this.errors = e.response.data;
      } else {
        this.showError(
          i18next.t('registerConfirmation.requestError.dialog.unknown.title'),
          i18next.t('registerConfirmation.requestError.dialog.unknown.body')
        );
      }
    } finally {
      this.confirmationIsLoading = false;
    }
  }

  public addError(property: string, constraintType: string, message: string): void {
    const errorExisting = this.errors.find(err => err.property === property);
    if (errorExisting) {
      errorExisting.constraints[constraintType] = message;
    } else {
      this.errors.push({
        property,
        constraints: { [constraintType]: message },
        children: [],
      });
    }
  }

  public showError(title: string, message: string): void {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        title,
        message,
      },
    });
  }
}
